export const timeData = [
  {
    name: `funnel query`,
    data: [
      [1530428400000, 1],
      [1533106800000, 1],
      [1535785200000, 3],
      [1538463600000, 10],
      [1541142000000, 28],
      [1543820400000, 7],
      [1546498800000, 10],
      [1549177200000, 11],
      [1551855600000, 3],
    ],
  },
  {
    name: `segmentation query`,
    data: [
      [1530428400000, 10],
      [1533106800000, 2],
      [1535785200000, 5],
      [1538463600000, 20],
      [1541142000000, 50],
      [1543820400000, 2],
      [1546498800000, 3],
      [1549177200000, 10],
      [1551855600000, 1],
    ],
  },
];

export const customData = [
  {
    name: `adopters`,
    data: [
      [-4, 1],
      [-3, 1],
      [-2, 3],
      [-1, 10],
      [0, 28],
      [1, 7],
      [2, 10],
      [3, 11],
      [4, 3],
    ],
  },
  {
    name: `non-adopters`,
    data: [
      [-4, 3],
      [-3, 10],
      [-2, 1],
      [-1, 0],
      [0, 5],
      [1, 3],
      [2, 2],
      [3, 1],
      [4, 5],
    ],
  },
];
